// Dependencies
require("grid");
require("section/generic");
require("element/rich-text");



/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/image/index.js
 ** module id = 30
 ** module chunks = 0 1
 **/